import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { API_BASE } from './config/api';

const API = API_BASE;   // direccion del backend: config/api.js (fuente unica)
const PP = "'Poppins', sans-serif";
// ENCAPSULAR-TUEXPO (2026-10-15): la tarjeta de TuExpo NO se enseña a nadie (Ricardo entra tecleando /expo).
// El selector lo ve cualquiera sin sesion y no tiene por que anunciar que el modulo existe. Para reabrir: true.
const MOSTRAR_TUEXPO = false;

// SELECTOR-LIMPIO (2026-10-16): la lista de aplicaciones que se ofrecen ANTES de iniciar sesion. Cada una dice si
// esta visible y a que ruta lleva. El selector decide SOLO por el numero de visibles: con UNA, entra directo a
// ella (hoy Beep OS) sin enseñar nada; con DOS o mas, enseña las tarjetas. No hay interruptor que acordarse de
// cambiar: el dia que TuExpo (u otra) vuelva a estar visible, el selector reaparece solo.
const APLICACIONES = [
  { id: 'beep', ruta: '/beep-login', visible: true },
  { id: 'expo', ruta: '/expo', visible: MOSTRAR_TUEXPO },
];
export const aplicacionesVisibles = () => APLICACIONES.filter(a => a.visible);

const pulsoVerdeCSS = `
@keyframes pulsoVerde{0%,100%{opacity:1}50%{opacity:0.5}}
.pulso-verde{animation:pulsoVerde 2s infinite}
`;

export default function Launcher() {
  const navigate = useNavigate();
  const visibles = aplicacionesVisibles();
  const hayExpo = visibles.some(a => a.id === 'expo');
  const [expoConfig, setExpoConfig] = useState(null);

  useEffect(() => {
    if (!hayExpo) return;   // sin tarjeta no hay nada que pedir (y la ruta contesta 404 sin sesion de dueño)
    fetch(`${API}/api/expo/config`)
      .then(r => r.json())
      .then(data => setExpoConfig(data))
      .catch(() => {});
  }, [hayExpo]);

  // Una sola aplicacion: no hay nada que elegir. Se entra directo y se SUSTITUYE la entrada del historial, para
  // que el boton "atras" del navegador no devuelva a un selector que vuelve a mandar al mismo sitio.
  if (visibles.length === 1) return <Navigate to={visibles[0].ruta} replace />;

  const irA = (id) => {
    const app = visibles.find(a => a.id === id);
    if (app) navigate(app.ruta);
  };

  const eventoNombre = expoConfig?.nombre || expoConfig?.evento || 'TuExpo Alianza';
  const eventoLogo = expoConfig?.logo || null;

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', fontFamily: PP }}>
      <style>{pulsoVerdeCSS}</style>

      {/* Header */}
      <div style={{
        background: '#185FA5',
        color: '#fff',
        textAlign: 'center',
        padding: '32px 20px 28px'
      }}>
        <div style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          background: '#fff',
          margin: '0 auto 12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }}>
          <img
            src="/Logo Original Cuadrado.png"
            alt="Beep México"
            style={{ width: 48, height: 48, objectFit: 'contain' }}
          />
        </div>
        <div style={{ fontSize: 20, fontWeight: 'bold' }}>Beep México</div>
        <div style={{ fontSize: 13, opacity: 0.7, marginTop: 4 }}>Selecciona tu aplicación</div>
      </div>

      {/* Cards */}
      <div style={{ padding: 20, maxWidth: 400, margin: '0 auto' }}>

        {/* Card 1 — Beep OS */}
        <div
          onClick={() => irA('beep')}
          style={{
            background: '#fff',
            borderRadius: 16,
            padding: 20,
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 14
          }}
        >
          <div style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            background: '#eef5ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 20,
            flexShrink: 0
          }}>
            <span style={{ color: '#185FA5' }}>🏢</span>
          </div>
          <div>
            <div style={{ fontSize: 17, fontWeight: 'bold', color: '#333' }}>Beep OS</div>
            <div style={{ fontSize: 13, color: '#999', marginTop: 2 }}>Sistema operativo empresarial</div>
            <span style={{
              display: 'inline-block',
              marginTop: 6,
              fontSize: 10,
              fontWeight: 'bold',
              color: '#185FA5',
              background: '#eef5ff',
              borderRadius: 6,
              padding: '2px 8px'
            }}>Acceso restringido</span>
          </div>
        </div>

        {/* Card 2 — TuExpo Alianza (ENCAPSULAR-TUEXPO: oculta para todos, ver MOSTRAR_TUEXPO arriba) */}
        {hayExpo && (
        <div
          onClick={() => irA('expo')}
          style={{
            background: '#270f2b',
            borderRadius: 16,
            padding: 20,
            marginTop: 12,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 14
          }}
        >
          {eventoLogo ? (
            <img
              src={eventoLogo}
              alt=""
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                objectFit: 'cover',
                flexShrink: 0
              }}
            />
          ) : (
            <div style={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 20,
              flexShrink: 0
            }}>🎪</div>
          )}
          <div>
            <div style={{ fontSize: 17, fontWeight: 'bold', color: '#94b803' }}>{eventoNombre}</div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>Control de montaje</div>
            <span
              className="pulso-verde"
              style={{
                display: 'inline-block',
                marginTop: 6,
                fontSize: 10,
                fontWeight: 'bold',
                color: '#00b894',
                background: 'rgba(0,184,148,0.2)',
                borderRadius: 6,
                padding: '2px 8px'
              }}
            >Montaje activo</span>
          </div>
        </div>
        )}

        {/* SELECTOR-LIMPIO (2026-10-16): la tarjeta "Mas aplicaciones - Proximamente" se quito. No llevaba a ningun
            sitio y era lo primero que veia quien entraba. */}

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: 32, fontSize: 11, color: '#aaa' }}>
          Beep México © 2026 · app.beepmexico.com
        </div>
      </div>
    </div>
  );
}
